import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { CIPStatusReportDetails } from '@/modules/Reports/ReportDetails';

const CIPStatusReportByEmployerIdPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.CARD_STATUS_REPORT,
      title: 'CIP Status',
    },
  ]);

  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  const { employerId } = useParams<{ employerId: string }>();
  if (!isHasPermission) {
    return null;
  }

  return (
    <Box width="100%" data-testid="topbar-wrapper">
      <div>
        <Topbar />
      </div>
      <Box>
        <Box margin={{ top: 'spacing24' }}>
          <CIPStatusReportDetails employerId={employerId} />
        </Box>
      </Box>
    </Box>
  );
};

export default CIPStatusReportByEmployerIdPage;
